import * as React from "react";
const SvgIconLeaf = props => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 7V15C8 15.5523 8.44772 16 9 16H17" stroke="#C6CCCE" strokeWidth={1.5} strokeLinecap="round" /></svg>;
export default SvgIconLeaf;